import { getSectionSupportLink, useSupportLink } from "@/hooks";
import {
  useAcceptancePolicyQuery,
  useSaasAgreementQuery,
} from "@/store/userAcceptance";
import {
  CButton,
  CCardBody,
  CCardImage,
  CCardText,
  CCardTitle,
  CContainer,
  CSpinner,
} from "@coreui/react-pro";
import React, { useState } from "react";
import Footer from "@/components/Footer";
import { Trans, useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";

interface UserAcceptanceProps {
  onAcceptClick?: () => void;
  onCancelClick?: () => void;
}
export const UserAcceptance: React.FC<UserAcceptanceProps> = ({
  onAcceptClick,
  onCancelClick,
}) => {
  const { currentData: infraMeterText } = useAcceptancePolicyQuery();
  const { currentData: saasAgreementText } = useSaasAgreementQuery();
  const [disableAccept, setDisableAccept] = useState(true);
  const { t } = useTranslation();
  const { pageLinks } = useSupportLink();
  const privacySupportLink = getSectionSupportLink("privacy-policy", pageLinks);
  const termsOfServiceLink = getSectionSupportLink(
    "terms-of-service",
    pageLinks
  );

  return (
    <>
      <CContainer>
        <CContainer className="useracceptance-top-rectangle">
          <CCardImage
            src="https://assets.infraview.app/public/infraview-color-vt.svg"
            className="useracceptance-logo"
          />
        </CContainer>
        <CContainer className="useracceptance-bottom-rectangle">
          <CCardTitle className="useracceptance-heading">
            {t("pages.userAcceptance.header")}
          </CCardTitle>
          <CContainer className="useracceptance-text ps-0">
            <CSpinner
              className="useracceptance-spinner"
              color="success"
              hidden={infraMeterText != undefined}
            ></CSpinner>
            <ReactMarkdown>{infraMeterText!}</ReactMarkdown>
          </CContainer>
          <CCardTitle className="useracceptance-sub-heading">
            {t("pages.userAcceptance.infrasightSaasAgreement")}
          </CCardTitle>
          <CCardText className="useracceptance-servicesReview">
            {t("pages.userAcceptance.servicesReview")}
          </CCardText>
          <CSpinner
            className="useracceptance-spinner"
            color="success"
            hidden={saasAgreementText != undefined}
          ></CSpinner>
          <CCardBody
            id="termsOfServiceId"
            className="useracceptance-terms-text"
            data-testid="termsOfServiceText"
            onScroll={(e: any) => {
              const bottom =
                e.target.scrollHeight - e.target.scrollTop <=
                e.target.clientHeight;
              if (bottom) {
                setDisableAccept(false);
              }
            }}
          >
            <ReactMarkdown>{saasAgreementText!}</ReactMarkdown>
          </CCardBody>
          <CCardTitle className="useracceptance-sub-heading">
            {t("pages.userAcceptance.termsOfServiceAndPrivacyPolicy")}
          </CCardTitle>
          <CCardText className="useracceptance-bottom-text">
            <Trans
              i18nKey="pages.userAcceptance.acceptanceDisclaimer"
              components={{
                privacyPolicy: (
                  <a
                    href={privacySupportLink}
                    target="_blank"
                    data-testid="Privacy-Policy-support-link"
                  />
                ),
                termsOfService: (
                  <a
                    href={termsOfServiceLink}
                    target="_blank"
                    data-testid="tos-support-link"
                  />
                ),
              }}
            />
          </CCardText>
          <CContainer className="useracceptance-btn-panel">
            <CButton
              variant="outline"
              shape="rounded-0"
              className="useracceptance-btn-cancel"
              onClick={onCancelClick}
            >
              {t("common.cancel")}
            </CButton>
            <CButton
              shape="rounded-0"
              className="useracceptance-btn-accept"
              onClick={onAcceptClick}
              disabled={disableAccept}
            >
              {t("pages.userAcceptance.accept")}
            </CButton>
          </CContainer>
        </CContainer>
      </CContainer>
      <Footer />
    </>
  );
};

export default React.memo(UserAcceptance);
